import Layout from 'components/layout/Layout'
import AppRouter from './AppRouter'
import '../styles/shared/shared.scss'
import styles from 'app/App.module.scss'
import '../../../../dist/libs/components/style.css'

export function App() {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.pageContent}>
          <AppRouter />
        </div>
      </div>
    </Layout>
  )
}
